let modulePromise: Promise<typeof import('./remote-selects')> | null = null;

function mount(root: ParentNode = document): void {
  const fields = [
    ...(root instanceof Element && root.matches('select[data-remote-select-url]') ? [root] : []),
    ...Array.from(root.querySelectorAll('select[data-remote-select-url]')),
  ];
  if (!fields.length) return;
  modulePromise ??= import('./remote-selects').catch(error => { modulePromise = null; throw error; });
  void modulePromise.then(module => module.mount(root)).catch(() => {
    fields.forEach(field => {
      if (!field.isConnected || field.nextElementSibling?.hasAttribute('data-remote-select-load-error')) return;
      const status = document.createElement('p');
      status.setAttribute('data-remote-select-load-error', ''); status.setAttribute('role', 'alert');
      status.className = 'small text-danger';
      status.textContent = 'No se pudo activar el buscador. Actualizá la página para reintentar.';
      field.after(status);
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
else mount();
document.addEventListener('htmx:afterSwap', event => mount((event as CustomEvent).detail?.target || document));
window.addEventListener('profint:controls-ready', () => mount());
